import getConfig from './config';
import getServiceAPIUrl from './service-api-url';
import getSupportedLocales from './supported-locales';

export default {
  getConfig,
  getServiceAPIUrl,
  getSupportedLocales,
};
